import { formatIntacctDate } from '@sit/client-shared';
import { stringWithFallback } from '@web/helpers/label';
import { useTheme } from '@web/styles/theme/hooks';
import { FlatTableCell, FlatTableRow } from 'carbon-react/lib/components/flat-table';
import Typography from 'carbon-react/lib/components/typography';
import { parseISO } from 'date-fns';
import { TimesheetBulkDeleteItem } from '../TimesheetModalContext';

interface TimesheetListItemProps {
  timesheet: TimesheetBulkDeleteItem;
  dateFormat: string;
}

export const TimesheetListItem = ({ timesheet, dateFormat }: TimesheetListItemProps) => {
  const { startDate: startDateString, endDate: endDateString, id, description } = timesheet;
  const theme = useTheme();

  // Just in case the dates are strings (they should be Date objects)
  const startDate = typeof startDateString === 'string' ? parseISO(startDateString) : startDateString;
  const endDate = typeof endDateString === 'string' ? parseISO(endDateString) : endDateString;

  return (
    <FlatTableRow key={id}>
      <FlatTableCell width={theme.spacing * 15}>
        <Typography mb={0}>{formatIntacctDate(startDate, dateFormat)}</Typography>
      </FlatTableCell>
      <FlatTableCell width={theme.spacing * 15}>
        <Typography mb={0}>{formatIntacctDate(endDate, dateFormat)}</Typography>
      </FlatTableCell>
      <FlatTableCell>
        <Typography mb={0}>{stringWithFallback(description)}</Typography>
      </FlatTableCell>
    </FlatTableRow>
  );
};
